/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GeoJson } from './GeoJson';
import {
    GeoJsonFromJSON,
    GeoJsonFromJSONTyped,
    GeoJsonToJSON,
} from './GeoJson';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
} from './Location';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';

/**
 * 
 * @export
 * @interface ErpWaypoint
 */
export interface ErpWaypoint {
    /**
     * 
     * @type {GeoJson}
     * @memberof ErpWaypoint
     */
    position?: GeoJson;
    /**
     * 
     * @type {Port}
     * @memberof ErpWaypoint
     */
    port?: Port;
    /**
     * 
     * @type {Location}
     * @memberof ErpWaypoint
     */
    location?: Location;
}

/**
 * Check if a given object implements the ErpWaypoint interface.
 */
export function instanceOfErpWaypoint(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ErpWaypointFromJSON(json: any): ErpWaypoint {
    return ErpWaypointFromJSONTyped(json, false);
}

export function ErpWaypointFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErpWaypoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'position': !exists(json, 'position') ? undefined : GeoJsonFromJSON(json['position']),
        'port': !exists(json, 'port') ? undefined : PortFromJSON(json['port']),
        'location': !exists(json, 'location') ? undefined : LocationFromJSON(json['location']),
    };
}

export function ErpWaypointToJSON(value?: ErpWaypoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'position': GeoJsonToJSON(value.position),
        'port': PortToJSON(value.port),
        'location': LocationToJSON(value.location),
    };
}

